import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type UserManagementViewModel } from '@/features/user-management/UserManagement/UserManagementViewModel'
import { UserManagementTableMenu } from '@/features/user-management/components/UserManagementTableMenu'

export interface UserManagementTableMenuContainerProps {
  vm: UserManagementViewModel
  /**
   * Replaces the default "more" button that opens the menu.
   */
  button?: ReactNode
}

export const UserManagementTableMenuContainer = observer(
  function UserManagementTableMenuContainer({
    vm,
    button,
  }: UserManagementTableMenuContainerProps) {
    return (
      <UserManagementTableMenu
        button={button}
        canManageGlobalCapacity={vm.canManageSelectedUsersGlobalCapacity}
        showWorkspaceActions={vm.showSelectedUsersWorkspaceActions}
        isShowingInactiveUsers={vm.userSearch.userInactiveFilter.value}
        onInvite={vm.workspaceInvitationVm.showWithSelections}
        onManageCapacity={vm.manageSelectedUsersCapacity}
        onRestore={vm.restoreSelectedUsers}
        onEditRoles={vm.editSelectedUsersRoles}
        onManageSkills={vm.manageSkillsVm.showWithSelections}
        onRemove={vm.removeSelectedUsers}
      />
    )
  },
)
